import { useTranslations } from 'next-intl';
import clsx from 'clsx';

import useStyles from './styles';

const NewLabel = () => {
  const t = useTranslations();
  const { root } = useStyles();

  return <span className={clsx(root, 'new-label')}>{t('new')}</span>;
};

export default NewLabel;
